





































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import AppButton from '@/modules/shared/components/AppButton'
import RegistrationProgress from '@/modules/instant/components/RegistrationProgress'
import { TournamentEntity } from '@/api/tournament'
import tournamentStore from '@/modules/tournament/tournament.store'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: {
    RegistrationProgress,
    AppButton
  }
})
export default class InstantMatchListItem extends Vue {
  @Prop({ default: false })
  comingSoon!: boolean

  @Prop({ required: true })
  tournament!: TournamentEntity

  tournamentModule = getModule(tournamentStore, this.$store)

  get registrationProgress() {
    if (this.comingSoon) {
      return 0
    }

    return Math.ceil(
      (this.tournament.totalRegisteredTeamNum /
        this.tournament.capacityMaxTeams) *
        100
    )
  }

  async checkPlayerList(tournament: TournamentEntity) {
    await this.$router.push({
      name: 'InstantMatchDetails',
      params: {
        tournamentId: tournament.tournamentId
      }
    })

    await this.tournamentModule.setAutomatedTournamentTeamListDialogVisible(
      true
    )
  }

  get entryFee() {
    if (!this.tournament.hasEntryFee || !this.tournament.entryFee) {
      return ''
    }

    return `${this.tournament.entryFee.currency} $${this.tournament.entryFee.amount}`
  }
}
